"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const NoticeOn = ({ width = 34, height = 34, fill }) => {
    const numericWidth = Number(width);
    const numericHeight = Number(height);
    const is24Icon = numericWidth === 24 && numericHeight === 24;
    const defaultFillCircle = '#FFFFFF';
    const defaultFillBell = '#8268D9';
    const defaultFillDot = '#C9BBF6';
    const on24FillCircle = '#479DA6';
    const on24FillInner = '#E6F0F1';
    const circleColor = fill || (is24Icon ? on24FillCircle : defaultFillCircle);
    const bellColor = fill || (is24Icon ? on24FillInner : defaultFillBell);
    const dotColor = fill || (is24Icon ? on24FillInner : defaultFillDot);
    return (react_1.default.createElement("svg", { width: width, height: height, viewBox: "0 0 34 34", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("circle", { cx: "17", cy: "17", r: "17", fill: circleColor }),
        react_1.default.createElement("path", { d: "M24.8921 22.8398C24.1911 21.6422 23.8225 20.292 23.8225 18.9193V14.0036C23.8225 10.8757 21.3225 8.31032 18.1423 8.05529V7.03014C18.1423 6.46256 17.6646 6 17.0727 6H16.9195C16.3302 6 15.8499 6.46006 15.8499 7.03014V8.05529C12.6698 8.31032 10.1697 10.8757 10.1697 14.0036V18.9193C10.1697 20.2945 9.80109 21.6447 9.10015 22.8398H9.10535C8.80161 23.3574 9.19102 24 9.80888 24H24.1911C24.809 24 25.1984 23.3599 24.8947 22.8398H24.8921Z", fill: bellColor }),
        react_1.default.createElement("path", { d: "M14 25.5141C14 26.3333 15.1433 27 16.5575 27H17.4425C18.8525 27 20 26.3358 20 25.5141V25H14.0042V25.5141H14Z", fill: dotColor })));
};
exports.default = NoticeOn;
